import { call, put, takeEvery, all } from 'redux-saga/effects';
import SectionApi from '../../api/SectionApi';
import * as Actions from '../actions/sectionsActions';
import * as Types from '../actions/sectionsActionTypes';
import * as AssessmentsActions from '../actions/assessmentsActions';
import * as StatusActions from '../actions/statusActions';

function* getSection(action) {
  try {
    const response = yield call(SectionApi.getSection, action.id);
    console.info(response);
    yield put(Actions.getSectionSuccess({ [action.id]: response }));
    yield put(StatusActions.receivedData(`section-${action.id}`));
  } catch (error) {
    console.info(error);
    yield put(Actions.getSectionFailure(error));
  }
}

function* getSections() {
  try {
    const response = yield call(SectionApi.getSections);
    yield put(Actions.getSectionsSuccess(response));
    yield put(StatusActions.receivedData('sections'));
  } catch (error) {
    console.info(error);
    yield put(Actions.getSectionsFailure(error));
  }
}

function* getSectionAndStart(action) {
  try {
    const response = yield call(SectionApi.getSection, action.id);
    console.info(response);
    yield put(Actions.getSectionSuccess({ [action.id]: response }));
    yield put(AssessmentsActions.navigateTo('questions', 0)); // begin assessment
    yield put(StatusActions.receivedData(`section-${action.id}`));
  } catch (error) {
    console.info(error);
    yield put(Actions.getSectionFailure(error));
    yield put(AssessmentsActions.navigateTo('questions', 0)); // placeholder until server responds
  }
}

export default function* sectionFlow() {
  yield all([
    takeEvery(Types.GET_SECTION, getSection),
    takeEvery(Types.GET_SECTIONS, getSections),
    takeEvery(Types.GET_SECTION_AND_START, getSectionAndStart),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/sectionFlow.js